import React from 'react';
import { ENVIRONMENTAL_STATUS_WIDGET_TYPE } from '../../../widgets/environmentalStatusConfig';
import { ASSET_STATUS_WIDGET_TYPE, STATUS_ARROW_WIDGET_TYPE } from '../../../widgets/assetStatusUtils';
import { PERIOD_COLUMN_WIDGET_TYPE } from '../../../utils/periodColumnWidget';
import ChartWidgetSettings from './ChartWidgetSettings';
import FanWidgetSettings from './FanWidgetSettings';
import LedWidgetSettings from './LedWidgetSettings';
import PeriodColumnWidgetSettings from './PeriodColumnWidgetSettings';
import TableWidgetSettings from './TableWidgetSettings';
import WidgetAdvancedSettings from './WidgetAdvancedSettings';
import WidgetBasicSettings from './WidgetBasicSettings';
import WidgetDatastreamSelectorSettings from './WidgetDatastreamSelectorSettings';
import WidgetDynamicPropsSettings from './WidgetDynamicPropsSettings';
import WidgetSettingsEditorColumn from './WidgetSettingsEditorColumn';
import WidgetSpecialSettings from './WidgetSpecialSettings';
import CameraStreamSettings from './CameraStreamSettings';

const WidgetSettingsEditorPanel = ({
	edit,
	setEdit,
	t,
	editFreeMovementEnabled,
	fontSizeFields,
	handleFontSizeBlur,
	handleFontSizeChange,
	showFreeGeometrySettings,
	geometryUnitLabel,
	geometryDrafts,
	setActiveGeometryField,
	handleGeometryDraftBlur,
	handleGeometryDraftChange,
	hasColorSettings,
	colorThemeMode,
	chartTypes,
	aggregations,
	devices,
	validDatastreams,
	deviceSelectOptions,
	setAddDatastream,
	isHiddenWidgetEditorPropKey,
	themeColorKey,
	themeColorValue,
	alignments,
	deviceDatastream,
	setDeviceDatastream,
	selectedDatastream,
	findDatastreamById,
	stripDatastreamManagedProps,
	clampToMinMax,
	applyDatastreamDefaultColors,
	remapColorStopsForDatastream,
	getDeviceTemplateSignature,
	periodOptions,
	periodStats,
	getDsMinMax,
	isStringDatastream,
	isNumericDatastream,
	getEffectiveMinMax,
	normalizeSliderValueInputChange,
	snapValueToStep,
	updateWidgetLivePropsById,
	directionLabels,
	setAlertMessage,
	setAlertType,
	setShowAlert,
}) => (
	<WidgetSettingsEditorColumn>
<WidgetBasicSettings
									edit={edit}
									setEdit={setEdit}
									t={t}
									editFreeMovementEnabled={editFreeMovementEnabled}
									fontSizeFields={fontSizeFields}
									handleFontSizeBlur={handleFontSizeBlur}
									handleFontSizeChange={handleFontSizeChange}
									showFreeGeometrySettings={showFreeGeometrySettings}
									geometryUnitLabel={geometryUnitLabel}
									geometryDrafts={geometryDrafts}
									setActiveGeometryField={setActiveGeometryField}
									handleGeometryDraftBlur={handleGeometryDraftBlur}
									handleGeometryDraftChange={handleGeometryDraftChange}
									hasColorSettings={hasColorSettings}
									colorThemeMode={colorThemeMode}
								/>
								{edit.type === 'chart' ?
									<ChartWidgetSettings
										edit={edit}
										setEdit={setEdit}
										t={t}
										chartTypes={chartTypes}
										aggregations={aggregations}
										devices={devices}
										validDatastreams={validDatastreams}
										deviceSelectOptions={deviceSelectOptions}
										setAddDatastream={setAddDatastream}
										isHiddenWidgetEditorPropKey={isHiddenWidgetEditorPropKey}
										themeColorKey={themeColorKey}
										themeColorValue={themeColorValue}
									/>
									: edit.type === 'table' ?
										<TableWidgetSettings
											edit={edit}
											setEdit={setEdit}
											t={t}
											chartTypes={chartTypes}
											aggregations={aggregations}
											devices={devices}
											validDatastreams={validDatastreams}
											deviceSelectOptions={deviceSelectOptions}
											setAddDatastream={setAddDatastream}
											isHiddenWidgetEditorPropKey={isHiddenWidgetEditorPropKey}
											themeColorKey={themeColorKey}
											themeColorValue={themeColorValue}
										/>
										: edit.type === 'fan' ? (
											<FanWidgetSettings
												edit={edit}
												setEdit={setEdit}
												t={t}
												devices={devices}
												validDatastreams={validDatastreams}
												deviceSelectOptions={deviceSelectOptions}
												setAddDatastream={setAddDatastream}
												setAlertMessage={setAlertMessage}
												setAlertType={setAlertType}
												setShowAlert={setShowAlert}
											/>
										)
										: edit.type === 'camera-stream' ? (
											<CameraStreamSettings
												edit={edit}
												setEdit={setEdit}
												t={t}
												devices={devices}
												validDatastreams={validDatastreams}
												deviceSelectOptions={deviceSelectOptions}
												setAddDatastream={setAddDatastream}
												setAlertMessage={setAlertMessage}
												setAlertType={setAlertType}
												setShowAlert={setShowAlert}
											/>
										) : ['background-image', 'box-widget', 'text-title', 'time-range', ENVIRONMENTAL_STATUS_WIDGET_TYPE, ASSET_STATUS_WIDGET_TYPE, STATUS_ARROW_WIDGET_TYPE].includes(edit.type) ? (
											<WidgetSpecialSettings
												edit={edit}
												setEdit={setEdit}
												alignments={alignments}
												devices={devices}
												validDatastreams={validDatastreams}
												deviceSelectOptions={deviceSelectOptions}
											/>
										)

											: <WidgetDatastreamSelectorSettings
											edit={edit}
											setEdit={setEdit}
											t={t}
											validDatastreams={validDatastreams}
											selectedDatastream={selectedDatastream}
											devices={devices}
											deviceSelectOptions={deviceSelectOptions}
											deviceDatastream={deviceDatastream}
											setDeviceDatastream={setDeviceDatastream}
											setAddDatastream={setAddDatastream}
											findDatastreamById={findDatastreamById}
											stripDatastreamManagedProps={stripDatastreamManagedProps}
											clampToMinMax={clampToMinMax}
											applyDatastreamDefaultColors={applyDatastreamDefaultColors}
											remapColorStopsForDatastream={remapColorStopsForDatastream}
											getDeviceTemplateSignature={getDeviceTemplateSignature}
											themeColorKey={themeColorKey}
											themeColorValue={themeColorValue}
										/>}

								<LedWidgetSettings
									edit={edit}
									setEdit={setEdit}
									t={t}
									themeColorKey={themeColorKey}
									themeColorValue={themeColorValue}
								/>

								{edit.type === PERIOD_COLUMN_WIDGET_TYPE ? (
									<PeriodColumnWidgetSettings
										edit={edit}
										setEdit={setEdit}
										t={t}
										periodOptions={periodOptions}
										periodStats={periodStats}
										selectedDatastream={selectedDatastream}
										getDsMinMax={getDsMinMax}
										themeColorKey={themeColorKey}
										themeColorValue={themeColorValue}
									/>
								) : null}

								<WidgetDynamicPropsSettings
									edit={edit}
									setEdit={setEdit}
									t={t}
									alignments={alignments}
									selectedDatastream={selectedDatastream}
									isStringDatastream={isStringDatastream}
									isNumericDatastream={isNumericDatastream}
									isHiddenWidgetEditorPropKey={isHiddenWidgetEditorPropKey}
									getEffectiveMinMax={getEffectiveMinMax}
									normalizeSliderValueInputChange={normalizeSliderValueInputChange}
									clampToMinMax={clampToMinMax}
									snapValueToStep={snapValueToStep}
									updateWidgetLivePropsById={updateWidgetLivePropsById}
									themeColorKey={themeColorKey}
									themeColorValue={themeColorValue}
								/>
								<WidgetAdvancedSettings
									edit={edit}
									setEdit={setEdit}
									t={t}
									selectedDatastream={selectedDatastream}
									directionLabels={directionLabels}
									getDsMinMax={getDsMinMax}
									themeColorKey={themeColorKey}
									themeColorValue={themeColorValue}
								/>
	</WidgetSettingsEditorColumn>
);

export default WidgetSettingsEditorPanel;
